import * as types from '../constants/dashboardConstants';
const initialState = {
  loading: false,
  loaded: false,
  isInitialApiLoaded: false,
  sessionTimeOut: false,
  changeLayoutFlag: 0,
  canLogout: false,
  settingmodal: false,
  updatedAccBal:[],
  defAcc: {},
  BMModel:false,
  LMTModel:false,
  addWidgetFlag:true,
  enableflag: false,
  dashboardWidgets:[],
  loadTempFlag:false,
  trdBookRandomNo: 0,
  toolTipFlag:true,
  deletewidgetflag:false,
  isMargin: true,
  cmdtyRandomNo:0,
  marginHeight:2,
  marginWidth:1,
  instrumentListHeight:1,
  instrumentListWidth:2,
  tradebookHeight:1,
  tradebookWidth:3,
  tradebookkey:'',
  chartWidth:2,
  chartHeight:2,
  chartkey:'',
  trdWidth:1,
  trdHeight:1,
  trdkey:'',
  tradePanelRandomNo:0,
  chartRandomNo:0,
  layout:[],
  layoutWindow:[],
  logoutFlag:false,
  closeLmtFlag:false,
  lmtKeyValue:'',
  langList:[],
  deleteWidgetKey:[],
  layoutModal:false,
  showProfileFlag:false,
  tradeWidgetCnt:0,
  loadTemplateChange:0,
  versionList:[],
  chartFlag:true,
  stkCodeList:[],
  closeFixFlag:false,
  fixKeyValue:'',
  validFixingOrders:[],
  fixingEvents:[],
  biometricDeviceList:[],
  deRegisterRandom:0,
  tempList:[]
};
//To make widgets not editable on initial fetch
const setWidgetStatic = (layout) => {
  try{
  layout.map(item => {
    item.static = false;
  });
}catch(e){console.log(e);}
  return layout;
};
const setComdtyPair = (layout, cmdtyPair) => {
    layout.map((item) => {
      let str = item.name;
      if(str === "Trade"){
        if(!item.cmdtyPair){
          const tco=JSON.parse(localStorage.getItem('TCO'));
          item.cmdyPair = tco[0][0];
        }
      }
    });
    return layout;
};
const getEdittedLayout = (layout,marginWidth,marginHeight,instrumentListWidth,instrumentListHeight,tradebookWidth,tradebookHeight,chartWidth,chartHeight,trdWidth,trdHeight,trdkey,tradebookkey,chartkey) => {
  layout.map((item) => {
    let str = item.i;
    const url = str.split('-', 3);
    const cmdtyPair1 = url[url.length - 2];
    const cmdtyPair2 = url[url.length - 1];
    const cmdtyPairCombined = cmdtyPair1 + '-' + cmdtyPair2;
    str = str.substring(0, str.indexOf('-'));
    switch (str) {
      case 'Instrument':
        item.name = 'InstrumentList';
        item.w=instrumentListWidth;
        item.h=instrumentListHeight;
        item.minW=1;
        item.maxW=5;
        item.minH=1;
        item.maxH=5;
        break;
      case 'Margin':
        item.name = 'Margin';
        item.w=marginWidth;
        item.h=marginHeight;
        item.minW=1;
        item.maxW=1;
        item.minH=1;
        item.maxH=2;
        break;
      case 'Trade':
        item.name = 'Trade';
        if(item.i == trdkey){
          item.w=trdWidth;
          item.h=trdHeight;
        }else{
          item.w=item.w;
          item.h=item.h;
        }
        item.minW=1;
        item.maxW=1;
        item.minH=2;
        item.maxH=2;
        if(item.cmdtyPair===""){
          const tco=JSON.parse(localStorage.getItem('TCO'));
          item.cmdtyPair=tco[0][0];
        }
        if(item.selectedTabKey !==undefined){
          item.selectedTabKey=item.selectedTabKey;
        }
        break;
      case 'TradeActivityBook':
        if(item.i == tradebookkey){
          item.w=tradebookWidth;
          item.h=tradebookHeight;
        }else{
          item.w=item.w;
          item.h=item.h;
        }
        item.minW=3;
        item.maxW=5;
        item.minH=1;
        item.maxH=5;
        item.name = 'TradeActivityBook';
        break;
      case 'Chart':
        if(item.i == chartkey){
          item.w=chartWidth;
          item.h=chartHeight;
        }else{
          item.w=item.w;
          item.h=item.h;
        }
        item.minW=2;
        item.maxW=5;
        item.minH=2;
        item.maxH=5;
        item.name = 'Chart';
        if(item.cmdtyPair=== undefined || item.cmdtyPair=== 'undefined'){
            const dco = JSON.parse(localStorage.getItem('DCO'));
            item.cmdtyPair = dco[0][0];
        }
        if(item.chartData === undefined || item.cmdtyPair=== 'undefined'){
          item.chartData=[{'dataType':'Live','graphType':'Candle Stick','category':'Ask','duration':'Minute','histGraphType':'Line'}]
        }
        break;
      default:
        break;
    }
  });
  return layout;
};

const appendDeletkey = (deletionWidgetsKey, keyValue) => {
    deletionWidgetsKey.push(keyValue);
    return deletionWidgetsKey;
};

const addWidgetSample = (widgetName, layoutAdd) => {
  let idName;
  let name;
  let width;
  let minW;
  let maxW;
  let height;
  let minH;
  let maxH;
  var cmdtyArr=[];
  layoutAdd.map((item) => {
    let str = item.i;
    str = str.substring(0, str.indexOf('-'));
    switch (str) {
      case 'Trade':
        cmdtyArr.push(item.cmdtyPair);
        break;
      default:
        break;
    }
  });
  var exceedCmdty = '';
  for(var i=0;i<cmdtyArr.length;i++){
    var cnt=1;
    for(var j=0;j<cmdtyArr.length;j++){
      if(cmdtyArr[i]==cmdtyArr[j]){
        cnt++;
      }
    }
    if(cnt>5){
      exceedCmdty=cmdtyArr[i];
      break;
    }
  }
  switch (widgetName) {
    case 'instrument':
      idName = 'Instrument-' + new Date();
      name = 'InstrumentList';
      width = 2;
      minW=1;
      maxW=5;
      minH=1;
      maxH=5;
      height = 1;
      break;
    case 'trade':
      const tco=JSON.parse(localStorage.getItem('TCO'));
      var cmdty='';
      if(exceedCmdty!=''){
        for(var i = 0; i < tco.length; i++) {
            if(tco[i][0] == exceedCmdty){
              i++;
              if(i>=tco.length){
                cmdty=tco[0][0];
                break;
              }else{
                cmdty=tco[i][0];
                break;
              }
            }
        }
      }else{
        cmdty=tco[0][0];
      }
      idName = 'Trade-' +cmdty+'-'+ new Date();
      name = 'Trade';
      width = 1;
      minW=1;
      maxW=1;
      minH=2;
      maxH=2;
      height = 1;
      break;
    case 'chart':
      idName = 'Chart-' + new Date();
      name = 'Chart';
      width = 2;
      minW=2;
      maxW=5;
      minH=2;
      maxH=5;
      height = 2;
      break;
    case 'margin':
      idName = 'Margin-' + new Date();
      name = 'Margin';
      width = 1;
      minW=1;
      maxW=1;
      minH=1;
      maxH=2;
      height = 1;
      break;
    case 'TradeActivityBook':
      idName = 'TradeActivityBook-' + new Date();
      name = 'TradeActivityBook';
      width = 3;
      minW=3;
      maxW=5;
      minH=1;
      maxH=5;
      height=1;
      break;
    default:
      break;
  }
  const obj = {  w: width,h: height,x: 0,y: 29, i: idName,minW: minW,maxW: maxW,minH: minH,maxH: maxH,static: false,name: name };
  if(widgetName === 'trade'){
    const tco=JSON.parse(localStorage.getItem('TCO'));
    if(exceedCmdty!=''){
      for(var i = 0; i < tco.length; i++) {
          if(tco[i][0] == exceedCmdty){
            i++;
            if(i>=tco.length){
              obj.cmdtyPair=tco[0][0];
              break;
            }else{
              obj.cmdtyPair=tco[i][0];
              break;
            }
          }
      }
    }else{
    obj.cmdtyPair = tco[0][0];
    }
  }
  const dataObj=[{'dataType':'Live','graphType':'Candle Stick','category':'Ask','duration':'Minute','histGraphType':'Line'}];
   if(widgetName === 'chart'){
     obj.chartData=dataObj;
   }
  layoutAdd.push(obj);
  return layoutAdd;
};

const isSessionTimeOut = (statusCode) => {
  if (statusCode === 401) {
   // localStorage.setItem('user', null);
    return true;
  }
  return false;
};
const isISerror = (statusCode) => {
  if (statusCode === 500) {
    return true;
  }
  return false;
};

const gettemplist = (templatesList) => {
  let tempList = templatesList;
  const initialDefTemp = templatesList.filter((d) => d.sysDef)
  if (initialDefTemp.length) {
    let initialDefTempObj = initialDefTemp[0]

    let initialDefTempData = JSON.parse(initialDefTemp[0].D)
    initialDefTempData.tmplData = getRefactoredSysGenTmplData(initialDefTempData.tmplData) //Refactor initial system generated default template
    initialDefTempObj.D = JSON.stringify(initialDefTempData)

    tempList = tempList.filter((d) => d.C !== initialDefTempObj.C)
    tempList.push(initialDefTempObj)
  }
  tempList.forEach((tempObj) => {
    if (initialDefTemp[0]?.C !== tempObj.C) {//Refactor other templates in the list except system generated default template
      let tempData = JSON.parse(tempObj.D)
      tempData.tmplData = getTCODCOWiseChartTradeTempData(tempData.tmplData)
      tempObj.D = JSON.stringify(tempData)
    }
  })
  return tempList.map((item, index) => {
    return {
      ...item
    };
  });
};

const changeId = (cmdyPair, currentId, layout, selectedTabKey) => {
  try{
    const newId = 'Trade-' + cmdyPair + '-' + new Date();
    layout.map((item) => {
    if (item.i === currentId) {
        item.i = newId;
        item.cmdtyPair = cmdyPair;
        item.selectedTabKey=selectedTabKey;
      }
    });
  }catch(e){console.log(e);}
  return layout;
};
const changeChartId = (cmdyPair, currentId, layout, template) => {
  try{
    layout.map((item) => {
    if (item.i === currentId) {
        item.cmdtyPair = cmdyPair;
        item.chartData =template;
      }
    });
  }catch(e){console.log(e);}
  return layout;
};

const getFixingEventList = (data) =>{
  //sort event list according to SRNO
  data.sort((a,b) =>(a.SRNO > b.SRNO) ? 1 : -1)
  return data;
}

const getRefactoredSysGenTmplData = (tmplData) => {
  const TCO = JSON.parse(localStorage.getItem("TradingInst"));
  const DCO = JSON.parse(localStorage.getItem("DisplayInst"));
  let chartTempData = tmplData.filter((d) => d.name === 'Chart')
  const tempDataWithoutChartTrade = tmplData.filter((d) => d.name !== 'Chart' && d.name !== 'Trade')
  const rectifiedTradeData = []
  TCO.forEach((cmdty, index) => {
    const widget = index + 1;
    if (widget <= 4) {
      let obj = {
        "w": 0,
        "h": 0,
        "x": 0,
        "y": 0,
        "i": "",
        "minW": 1,
        "maxW": 1,
        "minH": 2,
        "maxH": 2,
        "moved": false,
        "static": false,
        "name": "Trade",
        "cmdtyPair": ""
      };
      obj.i = `Trade-${cmdty}-${new Date()}`
      obj.cmdtyPair = cmdty
      if (TCO.length === 1) {
        obj.w = 2
        obj.h = 2
      } else if (TCO.length === 2) {
        obj.w = 1
        obj.h = 2
        if (widget === 2) { obj.x = 1; obj.y = 0 }
      } else if (TCO.length === 3) {
        if (widget === 1) { obj.w = 1; obj.h = 2 }
        if (widget === 2) { obj.w = 1; obj.h = 1; obj.x = 1; obj.y = 0 }
        if (widget === 3) { obj.w = 1; obj.h = 1; obj.x = 1; obj.y = 1 }
      } else {
        obj.w = 1
        obj.h = 1
        if (widget === 2) { obj.x = 1; obj.y = 0 }
        if (widget === 3) { obj.x = 0; obj.y = 1 }
        if (widget === 4) { obj.x = 1; obj.y = 1 }
      }
      rectifiedTradeData.push(obj)
    }
  })
  chartTempData = rectifyTemplateDynamically(chartTempData, DCO)
  return [...rectifiedTradeData, ...chartTempData, ...tempDataWithoutChartTrade];
}

const getDefaultWidget = (tmplData, state) => {
  let refactoredTmplData = tmplData;
  const defTemp = state.tempList.length ? state.tempList.filter((d) => d.isDef) : []
  const sysGeneratedTemp = state.tempList.length ? state.tempList.filter((d) => d.sysDef) : []
  //Refactor template 
  //1. When there is no default template in the list(in case user deletes all templates)
  //2. For initial system generated default template
  if (!defTemp.length || sysGeneratedTemp[0]?.isDef) {
    refactoredTmplData = getRefactoredSysGenTmplData(tmplData);
  } else {
    refactoredTmplData = getTCODCOWiseChartTradeTempData(tmplData)
  }
  return refactoredTmplData;
}

//Get assigned TCO and DCO template data in case user deletes previously assigned TCO and DCO which are in the saved template
const getTCODCOWiseChartTradeTempData = (defTempData) => {
  let tempData = defTempData;
  const DCO = JSON.parse(localStorage.getItem("DisplayInst"));
  const TCO = JSON.parse(localStorage.getItem("TradingInst"));
  let chartTempData = tempData.filter((d) => d.name === 'Chart')
  let tradeTempData = tempData.filter((d) => d.name === 'Trade')
  const tempDataWithoutChartTrade = tempData.filter((d) => d.name !== 'Chart' && d.name !== 'Trade')
  if (DCO.length) {
    chartTempData = rectifyTemplateDynamically(chartTempData, DCO)
    tempData = [...tempDataWithoutChartTrade, ...chartTempData]
  }
  if (TCO.length) {
    tradeTempData = rectifyTemplateDynamically(tradeTempData, TCO)
    tempData = [...tempData, ...tradeTempData]
  }
  return tempData;
}

const rectifyTemplateDynamically = (templateData, cmdtyDynamicData) => {
  const templateCommodity = templateData.map((d) => d.cmdtyPair)
  let rectifiedCommodities = [];
  let tempCmdtyMatch = [];
  //set commodity which matches the template commodity
  templateCommodity.forEach((cmdty, index) => {
    if (cmdtyDynamicData.includes(cmdty)) {
      rectifiedCommodities.push(cmdty);
      tempCmdtyMatch.push(index);
    }
  });
  //set commodity which don't matches the template commodity
  cmdtyDynamicData.forEach((cmdty) => {
    if (!templateCommodity.includes(cmdty) && tempCmdtyMatch.length !== templateCommodity.length) {
      rectifiedCommodities.push(cmdty);
    }
  });
  const rectifiedTemplateWidgets = templateData.filter((d, index) => rectifiedCommodities[index])// filtering out no. of widgets as per the count of rectified commodities 
  rectifiedTemplateWidgets.forEach((tempData, index) => {
    if (rectifiedCommodities[index]) {//set template data as per rectified commodities
      tempData.i = `${tempData.name}-${rectifiedCommodities[index]}-${new Date()}-${index}`
      tempData.cmdtyPair = rectifiedCommodities[index]
    }
  })
  return rectifiedTemplateWidgets;
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOAD_WIDGET:
      return {
        ...state
      };
    case types.LOAD_WIDGET_SUCCESS:
    return {
        ...state,
        clickedEdit: false,
        sessionTimeOut: false,
        deleteWidgetKey: [],
        layout: getDefaultWidget(action.result.dataObject[0].tmplData, state),
        layoutWindow: getDefaultWidget(action.result.dataObject[0].tmplData, state),
        tradeBookColumns:action.result.dataObject[0].tradeBookData,
        dashboardWidgets: getDefaultWidget(action.result.dataObject[0].tmplData, state)
      };
    case types.LOAD_WIDGET_FAILURE:
      return {
        ...state,
        sessionTimeOut: isSessionTimeOut(action.error.statusCode),
        showPopup: isSessionTimeOut(action.error.statusCode),
        internalServerError: isISerror(action.error.statusCode)
      };
    case types.SAVE_WIDGET_ACTIONS:
      return {
        ...state
      };
    case types.SAVE_WIDGET_ACTIONS_SUCCESS:
      return {
        ...state,
        sessionTimeOut: false,
        showPopup: false,
        internalServerError: false,
        deleteWidgetKey: [],
        //tempList: gettemplist(action.result.data.N),
        trdBookRandomNo: action.randomNo,
        logoutFlag:false
      };
    case types.SAVE_WIDGET_ACTIONS_FAILURE:
    return {
        ...state,
        sessionTimeOut: isSessionTimeOut(action.error.statusCode),
        showPopup: isSessionTimeOut(action.error.statusCode),
        internalServerError: isISerror(action.error.statusCode)
      };
    case types.EDIT_DASHBOARD:
      return {
        ...state,
        dashboardWidgets: state.dashboardWidgets,
        clickedEdit: action.clickedEdit,
        deleteWidgetKey: []
      };
    case types.SUCCESS_CHANGE_WIDGETS:
      if(window.innerWidth >= 1300){
        return {
        ...state,
        layout: getEdittedLayout(action.layout,state.marginWidth,state.marginHeight,state.instrumentListWidth,state.instrumentListHeight,state.tradebookWidth,state.tradebookHeight,state.chartWidth,state.chartHeight,state.trdWidth,state.trdHeight,state.trdkey,state.tradebookkey,state.chartkey),
        layoutWindow: getEdittedLayout(action.layout,state.marginWidth,state.marginHeight,state.instrumentListWidth,state.instrumentListHeight,state.tradebookWidth,state.tradebookHeight,state.chartWidth,state.chartHeight,state.trdWidth,state.trdHeight,state.trdkey,state.tradebookkey,state.chartkey),
        dashboardWidgets: getEdittedLayout(action.layout,state.marginWidth,state.marginHeight,state.instrumentListWidth,state.instrumentListHeight,state.tradebookWidth,state.tradebookHeight,state.chartWidth,state.chartHeight,state.trdWidth,state.trdHeight,state.trdkey,state.tradebookkey,state.chartkey),
        loadTempFlag:true,
        deletewidgetflag:true
      };
      } else{
        return {
        ...state,
        layout: getEdittedLayout(action.layout,state.marginWidth,state.marginHeight,state.instrumentListWidth,state.instrumentListHeight,state.tradebookWidth,state.tradebookHeight,state.chartWidth,state.chartHeight,state.trdWidth,state.trdHeight,state.trdkey,state.tradebookkey,state.chartkey),
        dashboardWidgets: getEdittedLayout(action.layout,state.marginWidth,state.marginHeight,state.instrumentListWidth,state.instrumentListHeight,state.tradebookWidth,state.tradebookHeight,state.chartWidth,state.chartHeight,state.trdWidth,state.trdHeight,state.trdkey,state.tradebookkey,state.chartkey),
        loadTempFlag:false,
        deletewidgetflag:true//added deletewidgetflag to solve white screen issue
        };
      }

    case types.DEFAULT_COMMODITYPAIR:
      return{
        ...state,
        layout: setComdtyPair(action.layout, action.cmdtyPair),
        layoutWindow: setComdtyPair(action.layout, action.cmdtyPair)
      }
    case types.SUCCESS_DELETION:
      return {
        ...state,
        deleteWidgetKey: appendDeletkey(state.deleteWidgetKey, action.keyValue),
        deletewidgetflag:false,//added deletewidgetflag to solve white screen issue
        isMargin:true
      };
    case types.ADD_SAMPLE_WIDGET:
      return {
        ...state,
        dashboardWidgets: addWidgetSample(action.widget, action.layoutAdd),
        loadTempFlag:false,
        isMargin:false
      };
    case types.IS_CMDTY_SELECTED:
      return {
        ...state,
        isCmdtySelected: action.isCmdtySelected
      };
    case types.HIDE_POPOUT:
      return {
        ...state,
        showPopup: false,
        internalServerError: false
      };
    case types.SESSION_TIMEOUT:
      return {
        ...state,
        sessionTimeOut: isSessionTimeOut(401)
      };
   case types.LOAD_TEMPLIST:
      return {
        ...state
      };
    case types.LOAD_TEMPLIST_SUCCESS:
    return {
        ...state,
        tempList: gettemplist(action.result.dataObject)
      };
    case types.LOAD_TEMPLIST_FAILURE:
      return {
        ...state
      };
    case types.UPDATE_TRADEBOOK_COLUMNS:
    localStorage.setItem('tradeBookColumns', JSON.stringify(action.updatedTrdCols));
    return{
      ...state,
      tradeBookColumns:action.updatedTrdCols
    };
    case types.LAYOUT_CHANGE_STATUS:
    const ChangedData = action.layoutCount;
       if (ChangedData > 0) {
        return {
          ...state,
          changeLayoutFlag: 1
        };
      };
      return {
        ...state
      };
    case types.UPDATE_CAN_LOGOUT:
    return{
      canLogout: false
    };
    case types.HANDLE_SETTING_MODAL:
    return {
      ...state,
      settingmodal: action.status
    };
    case types.LOAD_TEMPLATE:
    var loadTemplateRandomNumber=Math.floor((Math.random() * 100) + 1);
    return{
      ...state,
      tradeBookColumns:action.layout.tradeBookData,
      layout: action.layout.tmplData,
      layoutWindow: action.layout.tmplData,
      dashboardWidgets: action.layout.tmplData,
      deleteWidgetKey: [],
      loadTemplateChange:loadTemplateRandomNumber
      };
      case types.HANDLE_BM_MODAL:
      return{
      ...state,
      BMModel: action.BMpopup
      }
      case types.HANDLE_LMT_MODAL:
      return{
      ...state,
      LMTModel: action.LMTPopup
      }
      case types.CHANGE_ADDWIDGETFLAG:
      return{
      ...state,
      addWidgetFlag:action.addWidgetFlag,
      }
      case types.HANDLE_LAYOUT_FLAGMODAL:
        return {
          ...state,
          enableflag: action.status
        };
    case types.LOAD_TEMP_FLAG:
    return {
      ...state,
      loadTempFlag: action.flag
    };
    case types.CHANGE_COMMDTY:
    var randomNo= Math.floor((Math.random() * 10000) + 1);
      return {
        ...state,
        cmdtyPair: action.cmdyPair,
        cmdtyRandomNo:randomNo,
        layout: changeId(action.cmdyPair, action.currentId, action.layout, action.key),
      };
    case types.CHANGE_CHART_COMMDTY:
    var randomNo= Math.floor((Math.random() * 10000) + 1);
      return {
        ...state,
        cmdtyPair: action.cmdyPair,
        // cmdtyRandomNo:randomNo,
        layout: changeChartId(action.cmdyPair, action.currentId, action.layout, action.template),
      };
    case types.ENABLE_TOOLTIP:
    return {
      ...state,
      toolTipFlag: action.flag
    };
    case types.LOAD_ACCOUNT:
 	 return{
 	 	...state,
 	 };
 	 case types.LOAD_ACCOUNT_SUCCESS:
 	 return{
 	 	...state,
 	 	updatedAccBal: action.result.data
 	 };
 	 case types.LOAD_ACCOUNT_FAILURE:
 	 return{
 	 	...state,
  	}
    case types.MARGIN_LAYOUT:
    return{
      ...state,
      marginHeight:action.height,
      marginWidth:action.width
    }
    case types.INSTRUMENT_LAYOUT:
    return{
      ...state,
      instrumentListWidth:action.width,
      instrumentListHeight:action.height
    }
    case types.TRADEBOOK_LAYOUT:
    return{
      ...state,
      tradebookkey:action.key,
      tradebookWidth:action.width,
      tradebookHeight:action.height,
      trdBookRandomNo:Math.floor((Math.random() * 10000) + 1),
    }
    case types.CHART_LAYOUT:
    return{
      ...state,
      chartWidth:action.width,
      chartHeight:action.height,
      chartRandomNo:Math.floor((Math.random() * 10000) + 1),
      chartkey:action.key
    }
    case types.TRADEPANEL_LAYOUT:
    return{
      ...state,
      trdWidth:action.width,
      trdHeight:action.height,
      trdkey:action.key,
      tradePanelRandomNo:Math.floor((Math.random() * 10000) + 1)
    }
    case types.CLOSE_LMT_MODAL:
    return{
      ...state,
      closeLmtFlag:action.flag,
      lmtKeyValue:action.keyValue
    }

    case types.CHANGE_LOGOUT_FLAG:
    return{
      ...state,
      logoutFlag:action.logoutFlag
    }
    case types.LOAD_LANGUAGES:
       return {
         ...state
       };
   case types.LOAD_LANGUAGES_SUCCESS:
   return {
       ...state,
       langList: action.result.dataObject
     };
   case types.LOAD_LANGUAGES_FAILURE:
     return {
       ...state
     };
  case types.OPEN_LAYOUTMODAL_FLAG:
     return{
       ...state,
       layoutModal:action.layoutModal
     };
  case types.SHOW_PROFILE_FLAG:
    return{
       ...state,
       showProfileFlag:action.showProfileFlag
     };
  case types.TRADE_WIDGET_COUNT:
     return{
        ...state,
        tradeWidgetCnt:action.count
      };
  case types.DELETE_LAYOUT:
     return {
          ...state
        };
  case types.DELETE_LAYOUT_SUCCESS:
     return {
         ...state,
            tempList: gettemplist(action.result.dataObject)
        };
  case types.DELETE_LAYOUT_FAILURE:
      return {
          ...state,
      };
  case types.GET_VERSION_NUMBER:
     return {
          ...state
        };
  case types.GET_VERSION_NUMBER_SUCCESS:
     return {
         ...state,
            versionList: action.result.dataObject
        };
  case types.GET_VERSION_NUMBER_FAILURE:
      return {
          ...state,
      };
  case types.GET_FIXING_EVENTS:
     return {
          ...state
        };
  case types.GET_FIXING_EVENTS_SUCCESS:
     return {
         ...state,
        fixingEvents: getFixingEventList(action.result.dataObject)
        };
  case types.GET_FIXING_EVENTS_FAILURE:
      return {
          ...state,
      };
  case types.CHART_API_FLAG:
      return {
        ...state,
        chartFlag: action.flag
      };
   case types.LOAD_STKCODELIST:
       return {
         ...state
       };
   case types.LOAD_STKCODELIST_SUCCESS:
   return {
       ...state,
       stockCodeList: action.result.dataObject
     };
   case types.LOAD_STKCODELIST_FAILURE:
     return {
       ...state
     };
    case types.CLOSE_FIX_MODAL:
      return{
       ...state,
       closeFixFlag:action.flag,
       fixKeyValue:action.keyValue
     };
    case types.GET_VALID_FIXINGORDERS:
      return {
       ...state
      };
    case types.GET_VALID_FIXINGORDERSR_SUCCESS:
      return {
       ...state,
       validFixingOrders: getFixingEventList(action.result.dataObject)
      };
    case types.GET_VALID_FIXINGORDERS_FAILURE:
      return {
       ...state,
      };
    case types.HANDLE_FIX_MODAL:
       return{
         ...state,
         FIXPopup: action.FIXPopup
     }
     case types.LOAD_BIOMETRIC_DEVICE:
        return {
          ...state
        };
    case types.LOAD_BIOMETRIC_DEVICE_SUCCESS:
    return {
        ...state,
        biometricDeviceList: action.result.dataObject
      };
    case types.LOAD_BIOMETRIC_DEVICE_FAILURE:
      return {
        ...state
      };
      case types.LOAD_BIOMETRIC_DRESGISTER_DEVICE:
         return {
           ...state
         };
     case types.LOAD_BIOMETRIC_DRESGISTER_DEVICE_SUCCESS:
       var randomNo= Math.floor((Math.random() * 10000) + 1);
     return {
         ...state,
         deRegisterRandom: randomNo
       };
     case types.LOAD_BIOMETRIC_DRESGISTER_DEVICE_FAILURE:
       return {
         ...state
       };
      case types.IS_INITIAL_API_LOADED:
        return {
          ...state,
          isInitialApiLoaded: action.flag
       }
    default:
      return state;

  }
}
